import React, { useEffect, useState } from 'react';
import { Badge, Box, Checkbox, FormControl, FormLabel, Select, Text, Tooltip } from '@chakra-ui/react';
import { getConfigEmissorNfeMl } from '../../services/api';

// Emissor da NF-e das vendas do Mercado Livre: o padrao de cada conta (tela
// Notas Fiscais > Emissor ML) ou a escolha feita so para o lote.
export const EMISSOR_PADRAO = 'padrao';
export const EMISSOR_INTERNO = 'interno';
export const EMISSOR_ML = 'mercado_livre';

export const ehVendaMl = (origem) => origem === 'Mercado Livre' || origem === 'Mercado Shops';

export const formatarCnpj = (cnpj) => {
    const d = String(cnpj || '').replace(/\D/g, '');
    return d.length === 14 ? `${d.slice(0, 2)}.${d.slice(2, 5)}.${d.slice(5, 8)}/${d.slice(8, 12)}-${d.slice(12)}` : '';
};

// Final do CNPJ ("0002-85"): o que muda entre matriz e filiais.
const finalCnpj = (cnpj) => {
    const d = String(cnpj || '').replace(/\D/g, '');
    return d.length === 14 ? `${d.slice(8, 12)}-${d.slice(12)}` : '';
};

export const useConfigEmissorNfeMl = (ativo = true) => {
    const [config, setConfig] = useState(null);

    useEffect(() => {
        if (!ativo) return undefined;
        let vivo = true;
        getConfigEmissorNfeMl().then((dados) => {
            if (vivo && dados?.contas) setConfig(dados);
        });
        return () => { vivo = false; };
    }, [ativo]);

    return config;
};

// Quem emite a nota desta venda com a escolha da tela.
export const emissorDaVenda = (conta, escolha, config) => {
    const linha = config?.contas?.find((c) => Number(c.conta) === Number(conta));
    const tipo = escolha === EMISSOR_INTERNO || escolha === EMISSOR_ML ? escolha : (linha?.emissor_padrao || null);
    return { tipo, cnpj: linha?.cnpj || null };
};

const rotuloEmissor = (tipo) => (tipo === EMISSOR_INTERNO ? 'interno' : (tipo === EMISSOR_ML ? 'faturador ML' : '?'));

export const BadgeEmissor = ({ conta, escolha, config, ensaio = false }) => {
    const { tipo, cnpj } = emissorDaVenda(conta, escolha, config);
    if (!tipo) return null;

    const interno = tipo === EMISSOR_INTERNO;
    const texto = interno
        ? `Interno${cnpj ? ` · ${finalCnpj(cnpj)}` : ''}${ensaio ? ' · ensaio' : ''}`
        : 'Faturador ML';
    const dica = interno
        ? `Faturador interno (TAGA) com o CNPJ da conta ${conta}${cnpj ? ` (${formatarCnpj(cnpj)})` : ''}. O XML é anexado no envio do Mercado Livre.${ensaio ? ' Ensaio em homologação: sem valor fiscal e nada vai ao ML.' : ''}`
        : 'Faturador do próprio Mercado Livre (configuração fiscal da conta no ML).';

    return (
        <Tooltip label={dica} hasArrow>
            <Badge colorScheme={interno ? (ensaio ? 'purple' : 'cyan') : 'yellow'} variant="subtle" fontSize="9px" whiteSpace="nowrap">
                {texto}
            </Badge>
        </Tooltip>
    );
};

export const SeletorEmissorNfe = ({ valor, onChange, config, isDisabled = false, mostrarEnsaio = false, ensaio = false, onEnsaioChange }) => {
    const resumoPadrao = config?.contas?.length
        ? `Padrão: ${config.contas.map((c) => `conta ${c.conta} → ${rotuloEmissor(c.emissor_padrao)}`).join(' · ')}.`
        : '';
    const ensaioDisponivel = valor !== EMISSOR_ML;

    return (
        <Box bg="gray.50" borderWidth="1px" borderColor="gray.200" rounded="md" p={3}>
            <FormControl>
                <FormLabel htmlFor="seletor-emissor-nfe" fontSize="xs" fontWeight="bold" color="gray.600" mb={1}>
                    Emissor da NF-e das vendas do Mercado Livre
                </FormLabel>
                <Select
                    id="seletor-emissor-nfe"
                    size="sm"
                    bg="white"
                    value={valor}
                    onChange={(e) => onChange(e.target.value)}
                    isDisabled={isDisabled}
                >
                    <option value={EMISSOR_PADRAO}>Padrão de cada conta</option>
                    <option value={EMISSOR_INTERNO}>Interno (TAGA) — CNPJ de cada conta</option>
                    <option value={EMISSOR_ML}>Faturador do Mercado Livre</option>
                </Select>
                {resumoPadrao && (
                    <Text fontSize="11px" color="gray.700" fontWeight="semibold" mt={1}>{resumoPadrao}</Text>
                )}
                <Text fontSize="10px" color="gray.500" mt={1}>
                    No interno a nota sai com o CNPJ da conta do ML e as regras fiscais novas, e o XML é anexado no envio. Pacote (carrinho) sai em uma nota só.
                </Text>
            </FormControl>
            {mostrarEnsaio && (
                <Checkbox
                    mt={2}
                    size="sm"
                    colorScheme="purple"
                    isChecked={ensaio && ensaioDisponivel}
                    isDisabled={isDisabled || !ensaioDisponivel}
                    onChange={(e) => onEnsaioChange && onEnsaioChange(e.target.checked)}
                >
                    <Text fontSize="xs" fontWeight="semibold" color="purple.700">
                        Ensaio em homologação (sem valor fiscal, não grava nem envia ao ML)
                    </Text>
                </Checkbox>
            )}
        </Box>
    );
};
